import { createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import enhancers from './enhancers';
import rootReducer from './RootReducer';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'auth',
    'locations',
    'products',
    'customers',
    'traffic',
    'maintenanceStatuses',
    'vehicleTypes',
    'roles',
    'manufacturers'
  ]
};

const store = createStore(
  persistReducer(persistConfig, rootReducer),
  enhancers
);

export const persistor = persistStore(store);
export default store;
export type State = ReturnType<typeof rootReducer>;
